import { Alert, Backdrop, Box, Button, Chip, CircularProgress, CssBaseline, FormControl, FormHelperText, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Paper, Select, Snackbar, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Toolbar, styled } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { API_URL } from "../../Constants";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add"
import Modal from "../modal/Modal";
import EditIcon from '@mui/icons-material/Edit';
import { axiosClient, axiosClientCloud} from "../AxiosClient";
import { useNavigate } from 'react-router-dom';
import {
    COMMERCE_PORTAL_ACCESS_ELIGIBILITY_MESSAGE,
    COMMERCE_PORTAL_ACCESS_STATUS,
    getCommercePortalAccessErrorMessage,
    getCommercePortalAccessPresentation,
    inviteCommerceAdmin,
    isValidPortalEmail,
    normalizePortalEmail,
    sanitizeEmbeddedPortalAccess,
} from "./commercePortalAccess";
import CommercePortalAccessModal from "./CommercePortalAccessModal";
import { COMMERCE_SEARCH_DEBOUNCE_MS, buildCommerceSearch } from "./commerceSearch";
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';



const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const ButtonAdd = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    color: '#ffff',
    margin: '0px 1rem',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});

const TextMessage = styled(FormHelperText)({
    color: 'red'
})

const ButtonEdit = styled(Button)({
    color: '#161e55',
    '&:hover': {
        color: '#A8C8AF'
    }
})

const ButtonFile = styled(Button)(
    {
        flexGrow: 0,
        borderRadius: '20px',
        gap: '10px',
        backgroundColor: '#ffff',
        color: '#161e55',
        margin: '0px 1rem',
        border: '1px solid rgba(11, 10, 10, 0.17)',
        '&:hover': {
            backgroundColor: '#A8C8AF',
        },
    }
)

export default function Comercio() {
    const titleColumns = ['ID','Nombre','Ciudad','Industria','Contacto', 'Acceso al portal', ""];
    //const industryTypes = ["Ferreterias", "Muebles", "Bicicletas", "Hogar", "Salud", "Agro", "Autopartes"];
    //const departaments = ["Bogota", "Cesar", "Cundinamarca", "Huila", "Santander", "Tolima"];
    const periodicitiesDesembolso = ["Quincenal", "Mensual", "Bimestral", "Trimestral"];
    const whatsappVersions = ["V1", "V2"];
    const urlApi = API_URL;
    const [data, setData] = useState();
    const [isModal, setIsModal] = useState(false);
    const tipoDocumento = ['NIT','CC','CE'];
    const [razonSocial, setRazonSocial] = useState("");
    const [typeDocumento, setTypeDocumento] = useState("");
    const [numberDocument, setNumberDocument] = useState("");
    const [celular, setCelular] = useState("");
    const [department, setDepartment] = useState("");
    const [periodicityDesembolso, setPeriodicityDesembolso] = useState("");
    const [whatsappVersion, setWhatsappVersion] = useState("");
    const [bank, setBank] = useState("");
    const [address, setAddress] = useState("");
    const [numeroSedes, setNumeroSedes] = useState("");
    const [email, setEmail] = useState("");
    const [city, setCity] = useState("");
    const [webSite, setWebSite] = useState("");
    const [sector, setSector] = useState("");
    const [errorRazonSocial, setErrorRazonSocial] = useState(false);
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [severity, setSeverity] = useState("info")
    const [newCommerce, setNewCommerce] = useState(false);
    const rowsPerPage = 10;
    const [numberPage, setNumberPage] = useState(0);
    const [dataPage, setDataPage] = useState();
    const [modalEdit, setModalEdit] = useState(false);
    const [razonSocialEdit, setRazonSocialEdit] = useState("");
    const [typeDocumentEdit, setTypeDocumentEdit] = useState("");
    const [numberDocumentEdit, setNumberDocumentEdit] = useState("");
    const [cellphoneEdit, setCellphoneEdit] = useState("");
    const [addressEdit, setAddressEdit] = useState("");
    const [numeroSedesEdit, setNumeroSedesEdit] = useState("");
    const [emailEdit, setEmailEdit] = useState("");
    const [cityEdit, setCityEdit] = useState("");
    const [webSiteEdit, setWebSiteEdit] = useState("");
    const [deparmentEdit, setDepartmentEdit] = useState("");
    const [periodicityDesembolsoEdit, setPeriodicityEdit] = useState("");
    const [bankEdit, setBankEdit] = useState("");
    const [whatsappVersionEdit, setVersionEdit] = useState("");
    const [sectorEdit, setSectorEdit] = useState("");
    const [dataCommerceEdit, setDataCommerceEdit] = useState();
    const [errorRazonSocialEdit, setErrorRazonSocialEdit] = useState(false);
    const [commerceUuidEdit, setCommerceUuidEdit] = useState("");
    const [openBackdropEdit, setOpenBackdropEdit] = useState(false);
    const [openSnackbarEdit, setOpenSnackbarEdit] = useState(false);
    const [messageEdit, setMessageEdit] = useState("")
    const [desembolso, setDesembolso] = useState(false);
    const importerDocument = useRef(null);
    const [isImporter, setIsImporter] = useState(false);
    const [percentageComision, setPercentageComission] = useState("");
    const [percentageComisionEdit, setPercentageComissionEdit] = useState("");
    const [industryTypes, setIndustryTypes] = useState([]);
    const [departaments, setDepartaments] = useState([]);
    const [portalInvitationLoading, setPortalInvitationLoading] = useState({});
    const [selectedPortalCommerce, setSelectedPortalCommerce] = useState(null);
    const commercePageRequestId = useRef(0);
    const portalAccessMutationVersion = useRef(0);
    const portalAccessMutations = useRef(new Map());
    const [searcher, setSearcher] = useState("");
    const appliedSearch = useRef("");

    const navigate = useNavigate();

    const applyRecentPortalAccessMutations = (commerces, requestVersion) =>
        (commerces || []).map((commerce) => {
            const mutation = portalAccessMutations.current.get(commerce?.uuid);
            return mutation?.version > requestVersion
                ? {
                    ...commerce,
                    web: mutation.web,
                    portalEmail: mutation.portalEmail,
                }
                : commerce;
        });

    const handleInviteCommerceAdmin = async (commerce, portalEmail) => {
        if (!commerce?.uuid || !isValidPortalEmail(portalEmail)) {
            return false;
        }

        const normalizedPortalEmail = normalizePortalEmail(portalEmail);
        setPortalInvitationLoading((current) => ({
            ...current,
            [commerce.uuid]: true,
        }));
        try {
            const result = await inviteCommerceAdmin(
                axiosClient,
                commerce.uuid,
                normalizedPortalEmail
            );
            const web = sanitizeEmbeddedPortalAccess(result);
            portalAccessMutationVersion.current += 1;
            portalAccessMutations.current.set(commerce.uuid, {
                version: portalAccessMutationVersion.current,
                web,
                portalEmail: normalizedPortalEmail,
            });
            const updatePortalAccess = (commerceRow) =>
                commerceRow?.uuid === commerce.uuid
                    ? {
                        ...commerceRow,
                        web,
                        portalEmail: normalizedPortalEmail,
                    }
                    : commerceRow;
            setDataPage((current) => current?.map(updatePortalAccess));
            setData((current) =>
                current
                    ? {
                        ...current,
                        content: current.content?.map(updatePortalAccess),
                    }
                    : current
            );

            const successMessages = {
                CREATED: "Invitación enviada al correo indicado.",
                RESENT: "Invitación reenviada al correo indicado.",
                ALREADY_ACTIVE: "El comercio ya tiene acceso activo.",
            };
            setMessage(
                successMessages[result?.result] ||
                "El acceso al portal fue actualizado."
            );
            setSeverity("success");
            setOpenSnackbar(true);
            return true;
        } catch (error) {
            setMessage(getCommercePortalAccessErrorMessage(error));
            setSeverity("error");
            setOpenSnackbar(true);
            return false;
        } finally {
            setPortalInvitationLoading((current) => ({
                ...current,
                [commerce.uuid]: false,
            }));
        }
    };

    const handleOpenPortalAccessModal = (commerce) => {
        setSelectedPortalCommerce(commerce);
    };

    const handleClosePortalAccessModal = () => {
        const isLoading = Boolean(
            portalInvitationLoading[selectedPortalCommerce?.uuid]
        );
        if (!isLoading) {
            setSelectedPortalCommerce(null);
        }
    };

    const handleEnableCommercePortalAccess = async (portalEmail) => {
        const commerce = selectedPortalCommerce;
        const wasSuccessful = await handleInviteCommerceAdmin(
            commerce,
            portalEmail
        );
        if (wasSuccessful) {
            setSelectedPortalCommerce(null);
        }
    };

    const handleChangeRazonSocial = (event) => {
        setRazonSocial(event.target.value);
    }

    const handleChangeTypeDocumento = (event) => {
        setTypeDocumento(event.target.value);
    }

    const handleChangeNumberDocument = (event) => {
        setNumberDocument(event.target.value);
    }

    const handleChangeCelular = (event) => {
        setCelular(event.target.value);
    }

    const handleChangeAddress = (event) => {
        setAddress(event.target.value);
    }

    const handleChangeNumeroSedes = (event) => {
        setNumeroSedes(event.target.value);
    }

    const handleChangeEmail = (event) => {
        setEmail(event.target.value);
    }

    const handleChangeCity = (event) => {
        setCity(event.target.value);
    }

    const handleChangeWebSite = (event) => {
        setWebSite(event.target.value);
    }

    const handleChangeDepartment = (event) => {
        setDepartment(event.target.value)
    }

    const handleChangePeriodicityDesembolso = (event) => {
        setPeriodicityDesembolso(event.target.value)
    }

    const handleChangeWhatsappVersion = (event) => {
        setWhatsappVersion(event.target.value)
    }

    const handleChangeBank = (event) => {
        setBank(event.target.value)
    }

    const handleChangeSector = (event) => {
        setSector(event.target.value);
    }

    const handleChangeRazonSocialEdit = (event) => {
        setRazonSocialEdit(event.target.value)
    }

    const handleChangeTypeDocumentEdit = (event) => {
        setTypeDocumentEdit(event.target.value)
    }

    const handleChangeNumberDocumentEdit = (event) => {
        setNumberDocumentEdit(event.target.value)
    }

    const handleChangeCellphoneEdit = (event) => {
        setCellphoneEdit(event.target.value)
    }

    const handleChangeAddressEdit = (event) => {
        setAddressEdit(event.target.value)
    }

    const handleChangeNumeroSedesEdit = (event) => {
        setNumeroSedesEdit(event.target.value)
    }

    const handleChangeEmailEdit = (event) => {
        setEmailEdit(event.target.value)
    }

    const handleChangeCityEdit = (event) => {
        setCityEdit(event.target.value)
    }

    const handleChangeDeparmentEdit = (event) => {
        setDepartmentEdit(event.target.value)
    }

    const handleChangePeriodicityDesembolsoEdit = (event) => {
        setPeriodicityEdit(event.target.value)
    }

    const handleChangeBankEdit = (event) => {
        setBankEdit(event.target.value)
    }

    const handleChangeWhatsappVersionEdit = (event) => {
        setVersionEdit(event.target.value)
    }

    const handleChangeWebSiteEdit = (event) => {
        setWebSiteEdit(event.target.value)
    }

    const handleChangeSectorEdit = (event) => {
        setSectorEdit(event.target.value)
    }

    const handleChangePercentageComissionCommerce = (event) => {
        setPercentageComission(event.target.value)
    }

    const handleChangePercentageComissionEdit = (event) => {
        setPercentageComissionEdit(event.target.value)
    }

    const handleAddCommerces = () => {
        /* setIsModal(!isModal) */
        navigate('/homeAdmin/create-commerce-form');
    }

    const handleClosedModal = () => {
        setIsModal(!isModal)
        setRazonSocial("")
        setTypeDocumento("")
        setNumberDocument("")
        setCelular("")
        setAddress("")
        setNumeroSedes("")
        setEmail("")
        setCity("")
        setWebSite("")
        setSector("")
        setErrorRazonSocial(false)
        setDepartment("")
        setPeriodicityDesembolso("")
        setBank("")
        setWhatsappVersion("")
        setPercentageComission("")
    }

    const handleCloseModalEdit = () => {
        setModalEdit(!modalEdit)
        setRazonSocialEdit("")
        setTypeDocumentEdit("")
        setNumberDocumentEdit("")
        setCellphoneEdit("")
        setAddressEdit("")
        setNumeroSedesEdit("")
        setEmailEdit("")
        setCityEdit("")
        setWebSiteEdit("")
        setSectorEdit("")
        setCommerceUuidEdit("")
        setDepartmentEdit("")
        setPeriodicityEdit("")
        setBankEdit("")
        setVersionEdit("")
        setPercentageComissionEdit("")
        setErrorRazonSocialEdit(false)
    }

    const handleClosedSnanck = (event, reason) => {
        if(reason == 'clickaway'){
            return;
        }
        setOpenSnackbar(false)
        
    }

    const handleClosedSnackEdit = (event, reason) => {
        if(reason == 'clickaway') {
            return;
        }
        setOpenSnackbarEdit(false)
    }

    const handleSubmitCreateCommerces = (event) => {
        event.preventDefault();
        const body = {
            name: "",
            documentType: "",
            documentNumber: "",
            cellphone: "",
            address: "",
            companyName: "",
            locationsNumber: "",
            email: "",
            city: "",
            website: "",
            sectorCommerceUuid: "",
            regionUuid: "",
            periodicityDesembolso: "",
            bank: "",
            whatsappVersion: "",
            comissionPercentage: ""
        }
        const regex = {
            cellphone: /^\d{10}$/,
            numeroSedes: /^\d+$/,
            email: /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[\w-]+$/i,
        }

        if(razonSocial != ""){
            body.name = razonSocial;
            body.companyName = razonSocial;
            setErrorRazonSocial(false);
        } else {
            setErrorRazonSocial(true)
        }

        if(typeDocumento != ""){
            body.documentType = typeDocumento;
        } else {
            body.documentType = "CC"
        }

        if (numberDocument != "") {
            const number = numberDocument.replace()
            body.documentNumber = numberDocument.replace(/\s+/g, '');
        }

        if (celular != "") {
                body.cellphone = celular;
        }

        if (address != "") {
            body.address = address;
        }

        if (numeroSedes != "") {
                body.locationsNumber = numeroSedes;
        }

        if (department != "") {
            body.regionUuid = department;
        } else {
            body.regionUuid = null;
        }

        if (periodicityDesembolso != "") {
            body.periodicityDesembolso = periodicityDesembolso;
        } else {
            body.periodicityDesembolso = "Quincenal";
        }

        if (bank != "") {
            body.bank = bank;
        }

        if (whatsappVersion != "") {
            body.whatsappVersion = whatsappVersion;
        } else {
            body.whatsappVersion = "V1";
        }

        if (email != "") {
                body.email = email;
        }

        if (city != "") {
            body.city = city;
        }

        if (webSite != "") {    
            body.website = webSite;
        }

        if (sector != "") {
            body.sectorCommerceUuid = sector;
        } else {
            body.sectorCommerceUuid = null
        }

        if (percentageComision != "") {
            body.comissionPercentage = parseFloat(percentageComision)/100;
        } else {
            body.comissionPercentage = null
        }

        const regexValue = /^(100(\.0{1,2})?|(\d{1,2})(\.\d{1,2})?)$/;

        if(razonSocial!="" && regexValue.test(percentageComision) && (industryTypes.length === 0 || sector != "") && periodicityDesembolso != "" && (departaments.length === 0 || department != "")){
            setOpenBackdrop(true)
            setErrorRazonSocial(false);
            axiosClient.post('/v1/commerces', body, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                if (response.status === 200) {
                    // Manejo de una respuesta exitosa
                    handleClosedModal(); 
                    setOpenBackdrop(false);
                    setOpenSnackbar(true);
                    setMessage("Se creó exitosamente el comercio");
                    setSeverity("success");
                    setNewCommerce(true);
                } else {
                    // Manejo de una respuesta fallida
                    setOpenBackdrop(false);
                    setOpenSnackbar(true);
                    setMessage("Error en la creación del comercio");
                    setSeverity("error");
                }
            })
            .catch(error => {
                // Manejo de errores de red u otros errores
                setOpenBackdrop(false);
                setOpenSnackbar(true);
                setMessage("Error en la creación del comercio");
                setSeverity("error");
                console.log('Error:', error.message);
            });
        } else {
            setErrorRazonSocial(true);
        }
    }

    const handleDesembolso = () => {
        setDesembolso(!desembolso)
        if(desembolso) {
            setIsImporter(false)
        }
    }

    const hanldeImporter = () => {
        if(importerDocument.current?.files?.length > 0) {
            setIsImporter(true);
        } else {
            setIsImporter(false)
        }
    }

    const submitImporter = () => {
        const csv = new FormData();
        csv.append("file", importerDocument?.current?.files[0]);

        axiosClient.post('/v1/importer/desembolso', csv)
        .then(response => {
            if (response.status === 200) {
                handleDesembolso();
            } else {
                console.log("Error fetch");
            }
        })
        .catch(error => {
            console.log("Bad fetch: " + error.message);
        });
    }

    const fetchCommercePage = (page, searchTerm) => {
        const requestId = commercePageRequestId.current + 1;
        commercePageRequestId.current = requestId;
        const portalAccessVersionAtRequest =
            portalAccessMutationVersion.current;
        axiosClient.get(`/v1/commerces`, {
            params: {
                sort: 'oldId,asc',
                size: rowsPerPage,
                page,
                search: buildCommerceSearch(searchTerm),
            }
        })
        .then(response => {
            if (requestId !== commercePageRequestId.current) {
                return;
            }
            const content = applyRecentPortalAccessMutations(
                response.data.content,
                portalAccessVersionAtRequest
            );
            setData({
                ...response.data,
                content,
            });
            setDataPage(content);
        })
        .catch(error => {
            if (requestId !== commercePageRequestId.current) {
                return;
            }
            console.log("Bad request: " + error.message);
        });
    }

    useEffect(() => {
        if(localStorage.getItem('userUuid') == null) {
            window.location = '/admin';
        }

        fetchCommercePage(numberPage, appliedSearch.current);

        axiosClientCloud.get(`/v1/regions`)
        .then(response => {
            if (response.status === 200) {
                setDepartaments(response.data);
            } else {
                console.log("Error petition");
            }
        })
        .catch(error => {
            console.log("Error petition: " + error.message);
        });

        axiosClientCloud.get(`/v1/sectors-commerce`)
        .then(response => {
            if (response.status === 200) {
                setIndustryTypes(response.data);
            } else {
                console.log("Error petition");
            }
        })
        .catch(error => {
            console.log("Error petition: " + error.message);
        });

    }, [newCommerce])

    useEffect(() => {
        if (searcher === appliedSearch.current) {
            return undefined;
        }
        const timeoutId = setTimeout(() => {
            appliedSearch.current = searcher;
            setNumberPage(0);
            setDataPage(undefined);
            fetchCommercePage(0, searcher);
        }, COMMERCE_SEARCH_DEBOUNCE_MS);
        return () => clearTimeout(timeoutId);
    }, [searcher])

    const handleChangeSearcher = (event) => {
        setSearcher(event.target.value);
    }

    const handleClearSearcher = () => {
        setSearcher("");
    }

    const handleChangePage = (event, newPage) => {
        setNumberPage(newPage)
        fetchCommercePage(newPage, appliedSearch.current);
    }

    const handleEdit = (commerceUuid) => {
        navigate(`/homeAdmin/edit-commerce-form/${commerceUuid}`);
    }

    const renderPortalAccess = (commerce) => {
        const access = sanitizeEmbeddedPortalAccess(commerce?.web);
        const presentation = getCommercePortalAccessPresentation(access.status);
        const requiresEmailModal =
            access.status === COMMERCE_PORTAL_ACCESS_STATUS.NOT_PROVISIONED;
        const hasValidPortalEmail = isValidPortalEmail(commerce?.portalEmail);
        const isLoading = Boolean(portalInvitationLoading[commerce?.uuid]);

        return (
            <Stack spacing={1} alignItems="center">
                <Chip
                    color={presentation.color}
                    label={presentation.label}
                    size="small"
                />
                {presentation.actionLabel && (
                    <Button
                        aria-label={presentation.actionLabel}
                        disabled={
                            isLoading ||
                            (!requiresEmailModal && !hasValidPortalEmail)
                        }
                        onClick={() =>
                            requiresEmailModal
                                ? handleOpenPortalAccessModal(commerce)
                                : handleInviteCommerceAdmin(
                                    commerce,
                                    commerce?.portalEmail
                                )
                        }
                        size="small"
                        variant="outlined"
                    >
                        {isLoading ? (
                            <CircularProgress size={18} />
                        ) : (
                            presentation.actionLabel
                        )}
                    </Button>
                )}
                {!requiresEmailModal &&
                    !hasValidPortalEmail &&
                    presentation.actionLabel && (
                    <FormHelperText error>
                        {COMMERCE_PORTAL_ACCESS_ELIGIBILITY_MESSAGE}
                    </FormHelperText>
                )}
            </Stack>
        );
    };

    const handleEditCommerce = (event) => {
        event.preventDefault();

        const regex = /^(100(\.0{1,2})?|(\d{1,2})(\.\d{1,2})?)$/;

        if(razonSocialEdit != "" && regex.test(percentageComisionEdit)  && (industryTypes.length === 0 || sectorEdit != "") && periodicityDesembolsoEdit != "" && (departaments.length === 0 || setDepartmentEdit != "")) {
            setOpenBackdropEdit(true)
            const body = {
                name: razonSocialEdit,
                documentType: typeDocumentEdit=="" ? null : typeDocumentEdit,
                documentNumber: numberDocumentEdit,
                cellphone: cellphoneEdit,
                address: addressEdit,
                companyName: razonSocialEdit,
                locationsNumber: numeroSedesEdit,
                email: emailEdit,
                city: cityEdit,
                website: webSiteEdit,
                sectorCommerceUuid: sectorEdit=="" ? null : sectorEdit,
                regionUuid: deparmentEdit,
                periodicityDesembolso: periodicityDesembolsoEdit == "" ? null : periodicityDesembolsoEdit,
                bank: bankEdit,
                whatsappVersion: whatsappVersionEdit == "" ? null : whatsappVersionEdit,
                comissionPercentage: percentageComisionEdit == "" ? null : parseFloat(percentageComisionEdit)/100
            }
            setErrorRazonSocialEdit(false);
            axiosClient.patch(`/v1/commerces/${commerceUuidEdit}`, body)
            .then(response => {
                handleCloseModalEdit();
                setOpenBackdropEdit(false);
                setOpenSnackbarEdit(true);
                setMessageEdit("Se editó exitosamente el comercio");
                setTimeout(() => setSeverity("success"), 5000);
                setNewCommerce(commerceUuidEdit);
            })
            .catch(error => {
                setOpenBackdropEdit(false);
                setOpenSnackbarEdit(true);
                setMessageEdit("Error en la edición del comercio");
                setSeverity("error");
                console.log('Error: ' + error.message);
            });
        } else {
            setErrorRazonSocialEdit(true);
        }
    }

    return (
        <React.Fragment>
            {/* <Box sx={{display: 'flex'}}> */}
                <CssBaseline></CssBaseline>
                {/* <Header position="fixed"></Header> */}
                {/* <SideDrawer currentPage={'Comercios'}></SideDrawer> */}
                {/* <br></br> */}
                <Toolbar></Toolbar>
                <Box sx={{width: '100%'}}>
                    <Stack spacing={2}>
                        <Item>.</Item>
                        <Item></Item>
                        <Grid container spacing={2}>
                            <Grid item>
                                <Box display={'flex'}>
                                    <h1>Tablero de Comercios</h1>
                                    <Box display={'flex'} alignItems={'center'} >
                                    <ButtonAdd onClick={handleAddCommerces}><AddIcon /></ButtonAdd>
                                        {/* <ButtonAdd onClick={handleAddCommerces}><AddIcon></AddIcon></ButtonAdd> */}
                                    </Box>
                                    <Box display={'flex'} alignItems={'center'}>
                                        <ButtonAdd onClick={handleDesembolso}>Desembolso</ButtonAdd>
                                    </Box>
                                    <Box display={'flex'} alignItems={'center'}>
                                        <ButtonAdd onClick={() => navigate('/homeAdmin/comercios/facturas')}>Facturas</ButtonAdd>
                                    </Box>
                                    <Box display={'flex'} alignItems={'center'}>
                                        <ButtonAdd onClick={() => navigate('/homeAdmin/comercios/incentivos')}>Incentivos</ButtonAdd>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                        <Box display={'flex'} justifyContent={'flex-end'}>
                            <TextField
                                id="commerce-searcher"
                                label="Buscar comercio"
                                placeholder="Nombre, razón social, documento o ID"
                                variant="outlined"
                                size="small"
                                sx={{ width: { xs: '100%', md: '28rem' } }}
                                value={searcher}
                                onChange={handleChangeSearcher}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                    endAdornment: searcher && (
                                        <InputAdornment position="end">
                                            <IconButton aria-label="Limpiar búsqueda" edge="end" onClick={handleClearSearcher}>
                                                <ClearIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                        <Grid container spacing={2}>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            {titleColumns.map(title => (
                                                <TableCell key={title} align="center">{title}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {dataPage?.length === 0 ? (
                                            <TableRow>
                                                <TableCell align="center" colSpan={titleColumns.length}>
                                                    No se encontraron comercios
                                                </TableCell>
                                            </TableRow>
                                        ) : dataPage ? dataPage.map(commerce => (
                                            <TableRow key={commerce?.uuid} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell align="center">{commerce?.oldId}</TableCell>
                                                <TableCell align="center"><Link to={`/homeAdmin/sucursales/${commerce?.name}/${commerce?.uuid}`}>{commerce?.name}</Link></TableCell>
                                                <TableCell align="center">{commerce?.city}</TableCell>
                                                <TableCell align="center">{industryTypes?.filter(items => items.uuid === commerce?.sectorCommerceUuid)[0]?.name}</TableCell>
                                                <TableCell align="center">{commerce?.cellphone} / {commerce?.phone}</TableCell>
                                                <TableCell align="center">{renderPortalAccess(commerce)}</TableCell>
                                                <TableCell align="center"><ButtonEdit onClick={() => handleEdit(commerce.uuid)}><EditIcon></EditIcon></ButtonEdit></TableCell>
                                            </TableRow>
                                        )): (
                                            <TableRow>
                                                <TableCell align="center" colSpan={titleColumns.length}>
                                                    Cargando contenido
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                                <TablePagination 
                                    component="div"
                                    rowsPerPageOptions={[rowsPerPage]}
                                    count={data?.totalElements ?? 0}
                                    rowsPerPage={rowsPerPage}
                                    page={numberPage}
                                    onPageChange={handleChangePage}
                                />
                            </TableContainer>
                        </Grid>
                    </Stack>
                </Box>
                <Toolbar></Toolbar>
                <CommercePortalAccessModal
                    commerce={selectedPortalCommerce}
                    loading={Boolean(
                        portalInvitationLoading[selectedPortalCommerce?.uuid]
                    )}
                    onClose={handleClosePortalAccessModal}
                    onSubmit={handleEnableCommercePortalAccess}
                    open={Boolean(selectedPortalCommerce)}
                />
                {isModal && 
                    <Modal activeModal={isModal} handleModal={handleClosedModal}>
                        <Box textAlign={'center'}>
                            <h2>Creación de comercios</h2>
                        </Box>
                        <Box width={'80%'} margin={'1rem auto'} >
                            <form onSubmit={handleSubmitCreateCommerces}>
                                <Box mt={5}>
                                    <FormControl fullWidth>
                                        <TextField id="razon-social" label="Razón Social" variant="outlined" value={razonSocial} onChange={handleChangeRazonSocial}></TextField>
                                    </FormControl>
                                    {errorRazonSocial && <TextMessage></TextMessage>}
                                </Box>
                                <Box mt={5}>
                                    <FormControl fullWidth>
                                        <InputLabel id="tipo-documento">Tipo de documento</InputLabel>
                                        <Select labelId="tipo-documento" id="tipoDocumento" label='Tipo de documento' value={typeDocumento} onChange={handleChangeTypeDocumento}>
                                            {tipoDocumento.map(tipoDocument => (
                                                <MenuItem key={tipoDocument} value={tipoDocument}>{tipoDocument}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                                <Box mt={5}>
                                    <FormControl fullWidth>
                                        <TextField id="numero-documento" label='Número de Documento' variant="outlined" value={numberDocument} onChange={handleChangeNumberDocument}></TextField>
                                    </FormControl>
                                </Box>
                                <Box mt={5}>
                                    <FormControl fullWidth>
                                        <TextField id="celular" label='Celular' variant="outlined" value={celular} onChange={handleChangeCelular}></TextField>
                                    </FormControl>
                                </Box>
                                <Box mt={5}>
                                    <FormControl fullWidth>
                                        <InputLabel id="department">Departamento</InputLabel>
                                        <Select labelId="deparment" id="departamento" label='Departamento' value={department} onChange={handleChangeDepartment}>
                                            {departaments?.map(items => (
                                                <MenuItem key={items.uuid} value={items.uuid}>{items.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                                <Box mt={5}>
                                    <FormControl fullWidth>
                                        <TextField id="ciudad" label='Ciudad' variant="outlined" value={city} onChange={handleChangeCity}></TextField>
                                    </FormControl>
                                </Box>
                                <Box mt={5}>
                                    <FormControl fullWidth>
                                        <TextField id="direccion" label='Dirección' variant="outlined" value={address} onChange={handleChangeAddress}></TextField>
                                    </FormControl>
                                </Box>
                                <Box mt={5}>
                                    <FormControl fullWidth>
                                        <TextField id="numeroSedes" label='Número de sedes' variant="outlined" value={numeroSedes} onChange={handleChangeNumeroSedes}></TextField>
                                    </FormControl>
                                </Box>
                                <Box mt={5}>
                                    <FormControl fullWidth>
                                        <InputLabel id="periodicity-desembolso">Periodicidad de Desembolso</InputLabel>
                                        <Select labelId="periodicity-desembolso" id="periodicidadDesembolso" label='Periodicidad de Desembolso' value={periodicityDesembolso} onChange={handleChangePeriodicityDesembolso}>
                                            {periodicitiesDesembolso.map(items => (
                                                <MenuItem key={items} value={items}>{items}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                                <Box mt={5}>
                                    <FormControl fullWidth>
                                        <TextField id="banco" label='Banco' variant="outlined" value={bank} onChange={handleChangeBank}></TextField>
                                    </FormControl>
                                </Box>
                                <Box mt={5}>
                                    <FormControl fullWidth>
                                        <InputLabel id="sectors">Sector</InputLabel>
                                        <Select labelId="sectors" id="sector" label="Sector" value={sector} onChange={handleChangeSector}>
                                            {industryTypes?.map(items => (
                                                <MenuItem key={items.uuid} value={items.uuid}>{items.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                                <Box mt={5}>
                                    <FormControl fullWidth>
                                        <TextField id="website" label='Website' variant="outlined" type="url" value={webSite} onChange={handleChangeWebSite}></TextField>
                                    </FormControl>
                                </Box>
                                <Box mt={5}>
                                    <FormControl fullWidth>
                                        <TextField id="email" label='Email' variant="outlined" type="email" value={email} onChange={handleChangeEmail}></TextField>
                                    </FormControl>
                                </Box>
                                <Box mt={5}>
                                    <FormControl fullWidth>
                                        <InputLabel id="whatsapp-version">Versión de Whatsapp</InputLabel>
                                        <Select labelId="whatsapp-version" id="whatsappVersion" label='Versión de Whatsapp' value={whatsappVersion} onChange={handleChangeWhatsappVersion}>
                                            {whatsappVersions.map(items => (
                                                <MenuItem key={items} value={items}>{items}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                                <Box mt={5}>
                                    <FormControl fullWidth>
                                        <TextField id="comission-percentage" label='Porcentaje de comisión' placeholder="1.3%" variant="outlined" value={percentageComision} onChange={handleChangePercentageComissionCommerce}></TextField>
                                    </FormControl>
                                    { percentageComision != "" && !(/^(100(\.0{1,2})?|(\d{1,2})(\.\d{1,2})?)$/).test(percentageComision) ? <TextMessage>Debe ser numerico y estar entre 0 y 100</TextMessage> : ""}
                                </Box>
                                <Box mt={2} textAlign={'center'}>
                                    <ButtonAdd type="submit">Crear comercio</ButtonAdd>
                                </Box>
                                <Box display={'flex'} justifyContent={'center'}>
                                    {errorRazonSocial && <TextMessage>Error! El campo razon social, industria, departamento, periodicidad de desembolso, comisión no deben estar vacios</TextMessage>}
                                </Box>
                            </form>
                        </Box>
                    </Modal>
                    }
                    { modalEdit &&
                        <Modal activeModal={modalEdit} handleModal={handleCloseModalEdit}>
                            <Box textAlign={'center'}>
                                <h2>Edición de comercios</h2>
                            </Box>
                            <Box width={'80%'} margin={'1rem auto'} >
                                <form onSubmit={handleEditCommerce}>
                                    <Box mt={5}>
                                        <FormControl fullWidth>
                                            <TextField id="razon-social" label="Razón Social" variant="outlined" value={razonSocialEdit} onChange={handleChangeRazonSocialEdit}></TextField>
                                        </FormControl>
                                        {errorRazonSocialEdit && <TextMessage></TextMessage>}
                                    </Box>
                                    <Box mt={5}>
                                        <FormControl fullWidth>
                                            <InputLabel id="tipo-documento">Tipo de documento</InputLabel>
                                            <Select labelId="tipo-documento" id="tipoDocumento" label='Tipo de documento' value={typeDocumentEdit} onChange={handleChangeTypeDocumentEdit}>
                                                {tipoDocumento.map(tipoDocument => (
                                                    <MenuItem key={tipoDocument} value={tipoDocument}>{tipoDocument}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box mt={5}>
                                        <FormControl fullWidth>
                                            <TextField id="numero-documento" label='Número de Documento' variant="outlined" value={numberDocumentEdit} onChange={handleChangeNumberDocumentEdit}></TextField>
                                        </FormControl>
                                    </Box>
                                    <Box mt={5}>
                                        <FormControl fullWidth>
                                            <TextField id="celular" label='Celular' variant="outlined" value={cellphoneEdit} onChange={handleChangeCellphoneEdit}></TextField>
                                        </FormControl>
                                    </Box>
                                    <Box mt={5}>
                                        <FormControl fullWidth>
                                            <InputLabel id="department">Departamento</InputLabel>
                                            <Select labelId="deparment" id="departamento" label='Departamento' value={deparmentEdit} onChange={handleChangeDeparmentEdit}>
                                                {departaments.map(items => (
                                                    <MenuItem key={items.uuid} value={items.uuid}>{items.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box mt={5}>
                                        <FormControl fullWidth>
                                            <TextField id="ciudad" label='Ciudad' variant="outlined" value={cityEdit} onChange={handleChangeCityEdit}></TextField>
                                        </FormControl>
                                    </Box>
                                    <Box mt={5}>
                                        <FormControl fullWidth>
                                            <TextField id="direccion" label='Dirección' variant="outlined" value={addressEdit} onChange={handleChangeAddressEdit}></TextField>
                                        </FormControl>
                                    </Box>
                                    <Box mt={5}>
                                        <FormControl fullWidth>
                                            <TextField id="numeroSedes" label='Número de sedes' variant="outlined" value={numeroSedesEdit} onChange={handleChangeNumeroSedesEdit}></TextField>
                                        </FormControl>
                                    </Box>
                                    <Box mt={5}>
                                        <FormControl fullWidth>
                                            <InputLabel id="periodicity-desembolso">Periodicidad de Desembolso</InputLabel>
                                            <Select labelId="periodicity-desembolso" id="periodicidadDesembolso" label='Periodicidad de Desembolso' value={periodicityDesembolsoEdit} onChange={handleChangePeriodicityDesembolsoEdit}>
                                                {periodicitiesDesembolso.map(items => (
                                                    <MenuItem key={items} value={items}>{items}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box mt={5}>
                                        <FormControl fullWidth>
                                            <TextField id="banco" label='Banco' variant="outlined" value={bankEdit} onChange={handleChangeBankEdit}></TextField>
                                        </FormControl>
                                    </Box>
                                    <Box mt={5}>
                                        <FormControl fullWidth>
                                            <InputLabel id="sectors">Sector</InputLabel>
                                            <Select labelId="sectors" id="sector" label="Sector" value={sectorEdit} onChange={handleChangeSectorEdit}>
                                                {industryTypes?.map(items => (
                                                    <MenuItem key={items.uuid} value={items.uuid}>{items.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box mt={5}>
                                        <FormControl fullWidth>
                                            <TextField id="website" label='Website' variant="outlined" type="url" value={webSiteEdit} onChange={handleChangeWebSiteEdit}></TextField>
                                        </FormControl>
                                    </Box>
                                    <Box mt={5}>
                                        <FormControl fullWidth>
                                            <TextField id="email" label='Email' variant="outlined" type="email" value={emailEdit} onChange={handleChangeEmailEdit}></TextField>
                                        </FormControl>
                                    </Box>
                                    <Box mt={5}>
                                        <FormControl fullWidth>
                                            <InputLabel id="whatsapp-version">Versión de Whatsapp</InputLabel>
                                            <Select labelId="whatsapp-version" id="whatsappVersion" label='Versión de Whatsapp' value={whatsappVersionEdit} onChange={handleChangeWhatsappVersionEdit}>
                                                {whatsappVersions.map(items => (
                                                    <MenuItem key={items} value={items}>{items}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box mt={5}>
                                        <FormControl fullWidth>
                                            <TextField id="comission-percentage" label='Porcentaje de comisión' variant="outlined" value={percentageComisionEdit} onChange={handleChangePercentageComissionEdit}></TextField>
                                        </FormControl>
                                        { percentageComisionEdit != "" && !(/^(100(\.0{1,2})?|(\d{1,2})(\.\d{1,2})?)$/).test(percentageComisionEdit) ? <TextMessage>Debe ser numerico y estar entre 0 y 100</TextMessage> : ""}
                                    </Box>
                                    <Box mt={2} textAlign={'center'}>
                                        <ButtonAdd type="submit">Editar comercio</ButtonAdd>
                                    </Box>
                                    <Box display={'flex'} justifyContent={'center'}>
                                        {errorRazonSocialEdit && <TextMessage>Error! El campo razon social, industria, departamento, periodicidad de desembolso, comisión no deben estar vacios</TextMessage>}
                                    </Box>
                                </form>
                            </Box>
                        </Modal>
                    }
                    {desembolso && 
                        <Modal activeModal={desembolso} handleModal={handleDesembolso}>
                            <Box textAlign={'center'}>
                                <h2>Importar desembolso</h2>
                            </Box>
                            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', flexDirection: 'column', height: '50%'}}>
                                <Box mt={5} mb={2} display={'flex'} alignItems={'center'} border={'1px solid gray'} padding={'1rem'} borderRadius={'1rem'}>
                                    <InputLabel id="document">Archivo CSV</InputLabel>
                                    <ButtonFile onClick={(e) => importerDocument.current?.click()}>
                                        <input accept='.csv' type='file' multiple hidden ref={importerDocument} onChange={hanldeImporter}></input>
                                        Subir documento
                                    </ButtonFile>
                                </Box>
                                {isImporter && 
                                    <p>Documento cargado</p>
                                }
                                <Box sx={{display: 'flex', justifyContent: 'center', gap: '1rem'}}>
                                    <ButtonAdd onClick={submitImporter}>Cargar</ButtonAdd>
                                </Box>
                            </Box>
                        </Modal>
                    }
                    <Backdrop sx={{background: 'rgba(255,255,255,0.1)', zIndex: '5', width: '50%', margin: 'auto auto auto 30vw'}} open={openBackdrop}>
                        <CircularProgress color="success"/>
                    </Backdrop>
                    <Snackbar open={openSnackbar} autoHideDuration={5000} onClose={handleClosedSnanck}>
                        <Alert onClose={handleClosedSnanck} severity={severity} sx={{width: '100%'}}>{message}</Alert>
                    </Snackbar>
                    <Backdrop sx={{background: 'rgba(255,255,255,0.1)', zIndex: '5', width: '50%', margin: 'auto auto auto 30vw'}} open={openBackdropEdit}>
                        <CircularProgress color="success"/>
                    </Backdrop>
                    <Snackbar open={openSnackbarEdit} autoHideDuration={5000} onClose={handleClosedSnackEdit}>
                        <Alert onClose={handleClosedSnackEdit} severity={severity} sx={{width: '100%'}}>{messageEdit}</Alert>
                    </Snackbar>
            {/* </Box> */}
        </React.Fragment>
    )
}
